import { observer } from "mobx-react";
import FontBody2 from "../../components/fonts/font-body2/font-body2";
import {FONT_COLOR} from "../../components/fonts/font-props";
import IconTranslationIndicator from "../../components/icons/icon-translation-indicator/icon-translation-indicator";
import Icon from "../../components/icons/icon/icon";
import {Tooltip} from "../../components/tooltip/tooltip";
import {IValidationGroup} from "../../hooks/validation-group/validation-group-hook";
import useTranslation from "../hooks/translation-hook";
import { EDITOR_VARIANT, RichTextEditor } from "../../components/rich-text-editor/rich-text-editor";

interface IProps {
    translationKey?: string;
    disabled?: boolean;
    minHeight?: number;
    maxHeight?: number;
    variant?: EDITOR_VARIANT,
    linkAlwaysBlank?: boolean,
    required?: boolean;
    validationGroup?: IValidationGroup;
    pastePlain?: boolean;
}

const TranslationRichTextEditor: React.FC<IProps> = observer(({
    translationKey,
    disabled,
    minHeight,
    maxHeight,
    variant,
    linkAlwaysBlank = true,
    validationGroup,
    required,
    pastePlain = false,
}: IProps) => {
    const { setTranslation, getTranslation} = useTranslation();

    const onChange = (val: any) => {
        if (translationKey && translationKey.trim() !== '') {
            /** this is the only place where we savinfg translations with type html */
            setTranslation(translationKey as string, val, undefined, 'html');
        }
        else {
            console.error('attempt to set translation without key');
        }
    }

    const indicator = () => <IconTranslationIndicator color={'var(--color-primary-1)'} />;

    return (
        <div className='translation-input'>
        <RichTextEditor
            value={getTranslation(translationKey as string)}
            onChange={onChange}
            disabled={disabled}
            minHeight={minHeight}
            maxHeight={maxHeight}
            variant={variant}
            linkAlwaysBlank={linkAlwaysBlank}
            validationGroup={validationGroup}
            required={required}
            pastePlain={pastePlain}
        />
            <Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>Translatable field</FontBody2>}>
                <Icon Component={indicator} />
            </Tooltip>


        </div>

    );
});

export default TranslationRichTextEditor;
